import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import FooterStteper from "./footerStteper/FooterStteper";
import StepperHeader from "./headerStteper/StteperHeader";
import StepperContent from "./contentStteper/ContentStteper";
import classes from "./Stepper.module.css";


const Stepper = ({ children, end, onCancel = true }) => {

    const validChildren = useMemo(() => React.Children.toArray(children).filter(child => React.isValidElement(child)), [children]);
    const [currentStep, setCurrentStep] = useState(0)
    const { texts } = useSelector(state => state.translate);

    const handlePrevClick = () => {
        if (currentStep > 0)
            setCurrentStep(prev => prev - 1)
    }

    const handleNextClick = () => {
        if (currentStep < validChildren?.length - 1)
            setCurrentStep(prev => prev + 1)
        else {
            end()
        }
    }

    return (
        <div className={classes.Stepper}>
            <StepperHeader
                currentStep={currentStep}
                validChildren={validChildren}
                texts={texts}
                onPrev={handlePrevClick}
            />

            <StepperContent
                currentStep={currentStep}
                validChildren={validChildren}
                setCurrentStep={setCurrentStep}
                goToNextStep={handleNextClick}
            />

            <FooterStteper
                onCancel={onCancel}
                end={end}
                validChildren={validChildren}
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                onNext={handleNextClick}
            >
                {validChildren[currentStep]?.props?.footerChildren}
            </FooterStteper>
        </div>
    )
}

const Step = ({ prev, prevFunc, nextFunc, nextText, title, disable, children, middleBtn, footerChildren, hideFooter, showCancel, cancelText }) => { }

export { Step, Stepper };